import React from "react"
import { Message } from "../../models"
import styled from '~/ui/styled'
import { ImageMessage } from "./image-message"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import MessageTime from "./message-time"
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import { Flex } from "~components/El"

const Container = styled.View`
  width: auto;
  max-width: min(40vw, 240px);
  flex-direction: row;
  flex-wrap: wrap;
`

const TimeWrap = styled(Flex)<{ byMe: boolean }>`
  justify-content: ${({ byMe }) => (byMe ? "flex-end" : "flex-start")};
  margin-top: 4px;
`

interface ImagesMessageProps {
  message: Message
  setPopupOptionListModal?: ({ visible, message }: { visible: boolean; message: Message }) => void
}

// 优化使用纯组件
export const ImagesMessage: React.FC<ImagesMessageProps> = observer(
  ({ message, setPopupOptionListModal }) => {
    return (
      <Container>
        {message?.attach?.imgs?.map((img: any) => {
          return (
            <ImageMessage
              key={`${message.message_id}-${img.uri || img.url}`}
              setPopupOptionListModal={setPopupOptionListModal}
              message={message}
              showTime={false}
              messageHack={{
                attach_path: img.uri,
                url: img.url,
                progress: img.progress,
                isUploading: img.isUploading,
              }}
            />
          )
        })}
        <TimeWrap byMe={message.byMe}>
          <MessageTime time={message.created} />
        </TimeWrap>
      </Container>
    )
  },
)
export const WrappedImagesMessage: React.FC<MessageProps & ImagesMessageProps> = (props) => {
  return props.message.byMe ? (
    <MessageSent {...props} Component={ImagesMessage} isNoBg={true} />
  ) : (
    <MessageReceived {...props} Component={ImagesMessage} isNoBg={true}/>
  )
}
export default WrappedImagesMessage
